import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  phoneFijo: "",
  phoneMobile: "",
};

const contactoPersonaSlice = createSlice({
  name: "contactoPersona",
  initialState,
  reducers: {
    contactoPersonaPhoneFijo: (state, action) => {
      state.phoneFijo = action.payload.phoneFijo;
    },
    contactoPersonaPhoneMobile: (state, action) => {
      state.phoneMobile = action.payload.phoneMobile;
    },
    contactoPersonaClear: (state) => {
      state.phoneFijo = "";
      state.phoneMobile = "";
    },
  },
});

export const {
  contactoPersonaPhoneFijo,
  contactoPersonaPhoneMobile,
  contactoPersonaClear,
} = contactoPersonaSlice.actions;

export default contactoPersonaSlice.reducer;
